import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const DiscountDisclaimer = styled.span`
  box-sizing: border-box;
  background: ${({ theme: { colors } }) => colors.b2cRedThl};
  border: 0.1rem solid ${({ theme: { colors } }) => colors.b2cRedThl};
  border-radius: 0.2rem;
  color: ${({ theme: { colors } }) => colors.b2cWhite};
  text-align: center;
  padding: 0.64rem 0.896rem 0 0.896rem;
  font-size: 1.28rem;
`;

export const Price = styled.span`
  color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
  font-weight: 600;
  font-size: 2.5rem;
`;

export const PreDiscountPriceSpan = styled.span`
  font-weight: 400;
  font-size: 1.28rem;
  line-height: 1.92rem;
  text-decoration-line: line-through;
  color: ${({ theme: { colors } }) => colors.b2cRedThl};
`;

export const PriceDescriptionSpan = styled.span`
  color: ${({ theme: { colors } }) => colors.b2cDarkBlack};
  font-size: 1.28rem;
  font-weight: 400;
  line-height: 1.92rem;
`;
